import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  tblRoot: {
    "&.MuiTableContainer-root": {
      width: "100%",
    },
  },
  tblHead: {
    "&.MuiTableHead-root": {
      "& .MuiTableRow-root": {
        "& .MuiTableCell-root": {
          borderRight: `1px solid`,
          borderBottom: `1px solid`,
          borderTop: `1px solid`,
          padding: 5,
          // paddingBlock: 2,
          fontWeight: 600,
          fontSize:15,
          textAlign: "center",
        },
      },
    },
  },
  tblRow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        paddingTop: 5,
        // paddingBlockEnd: 4,
        borderRight: `1px solid`,
        borderBottom: `1px solid`,
      },
    },
  },
  tblCell: {
    "&.MuiTableCell-root": {
      borderRight: "2px solid #000",
      fontWeight: 600,
    },
  },
  subRow: {
    "&.MuiTableRow-root": {
        borderLeft: "2px solid #000",
        borderBottom: "2px solid #000",
      "& .MuiTableCell-root": {
        padding:5,
        paddingBlock:7,
        borderBottom: "2px solid #000",

      },
    },
  },
  headCell: {
    "&.MuiTableCell-root": {
      borderTop: "1px solid black",
      borderBottom: "1px solid black",
      padding : 0,
      paddingBlock : 2,
      color:'black',
      fontSize:10,
    },
  },

tblRowCell: {
   '&.MuiTableRow-root':{
    "& .MuiTableCell-root": {
      padding : 0,
      paddingBlock : 2,
      borderBottom:'1px solid black',
      fontSize:10,
      color : 'black',
    },
   }
  },
  tblSubCell: {
    '&.MuiTableRow-root':{
     "& .MuiTableCell-root": {
       padding : 0,
       paddingBlock : 2,
       color : 'black',
     },
    }
   },
  pdfTitle:{
    "&.MuiTypography-root":{
      fontWeight:700,
      fontSize:19
    }
  },
  pdfText:{
    "&.MuiTypography-root":{
      fontSize:16
    }
  },
  pdfUnderLine:{
    "&.MuiTypography-root":{
      textDecoration:"underline",fontSize:16,fontWeight:700
    }
  },
  pdfFlex:{
    display:"flex"
  },
  pdfFlexBetween:{
    display:"flex",
    justifyContent:"space-between"
  },
  pdfTextTable:{
    "&.MuiTypography-root":{
      fontSize:15,
      fontWeight:600,
      marginInlineStart:2
    }
  }
}));
